// #90 SealedCard: an interviewer's scorecard tile before the Reveal (Card2 + mc-sealed). It shows only the person
// row, the assigned values and skills as chips, and the status pill (*Submitted* · *Past Due* · *Waived*), with the
// lock glyph in the header. No rating, recommendation or evidence is passed in, so none can leak.

import { cx } from "../lib/cx";
import { Card2 } from "../core/Card";
import { Chip, Chips } from "../core/Chip";
import { Icon } from "../core/icons";
import { Person, type PersonProps } from "../core/Person";
import { Pill } from "../core/Pill";

export interface SealedCardProps {
  person: Omit<PersonProps, "size" | "className" | "right">;
  /** The assigned values and skills (his words: ROOTS names, skill names). */
  assigned: readonly string[];
  /** The scorecard's status word: Submitted · Past Due · Waived. */
  status: string;
  can?: boolean | undefined;
  className?: string | undefined;
}

export function SealedCard({ person, assigned, status, can, className }: SealedCardProps) {
  return (
    <Card2 can={can} className={cx("mc-sealed", className)}>
      <div className="mc-sealed-h">
        <Person size={32} {...person} />
        <span className="mc-sealed-x">
          <Pill>{status}</Pill>
          <span className="mc-sealed-lock"><Icon name="lock" size={16} /></span>
        </span>
      </div>
      <Chips>
        {assigned.map((word) => <Chip key={word} sm val>{word}</Chip>)}
      </Chips>
    </Card2>
  );
}
